import {Component, inject} from '@angular/core';
import {RouterLink} from "@angular/router";
import {PRIVACY_CONTENT_ID} from "../../constants/content-constants/content-constants";
import {ContentModalComponent} from "../../libs/modals/content-modal/content-modal.component";
import {MatDialog} from "@angular/material/dialog";

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [
    RouterLink
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {

  private dialog = inject(MatDialog);

  privacyPolicyShow() {
    let dialogRef = this.dialog.open(ContentModalComponent, {
      data: {
        contentId: PRIVACY_CONTENT_ID,
      },
    });
    dialogRef.beforeClosed().subscribe(result => {
    });
  }

}
